import type { ReactNode } from 'react'
import { SplitView, SplitViewMain, SplitViewSide } from '@/components/SplitView'
import styles from './JobRoot.module.css'

export interface JobRootProps {
  list?: ReactNode
  isListCollapsed: boolean
  highlightBorder: boolean
  children?: ReactNode
}

/**
 * Job root screen.
 */
export function JobRoot({
  list,
  isListCollapsed,
  highlightBorder,
  children,
}: JobRootProps) {
  return (
    <div className={styles.container}>
      <div className={styles.fullHeight}>
        <SplitView>
          {list && (
            <SplitViewSide
              collapsed={isListCollapsed}
              highlightBorder={highlightBorder}
            >
              {list}
            </SplitViewSide>
          )}

          <SplitViewMain>{children}</SplitViewMain>
        </SplitView>
      </div>
    </div>
  )
}

export interface JobRootRefreshProps {
  list?: ReactNode
  listWidth: number
  listResizeHandle?: ReactNode
  children?: ReactNode
}

export function JobRootRefresh({
  list,
  listWidth,
  listResizeHandle,
  children,
}: JobRootRefreshProps) {
  return (
    <div className={styles.refresh}>
      {list && (
        <aside
          className={styles.list}
          style={{ width: listWidth }}
          aria-label="My jobs"
        >
          {list}
          {listResizeHandle}
        </aside>
      )}
      <main className={styles.detail}>{children}</main>
    </div>
  )
}
